<template lang="pug">
.search-box
	header.search-box__header
		h1.page-title.search-box__heading Search

	.search-box__body
		.search-box__form
			input.search-box__input(
				v-model="query",
				@keyup.enter="submitSearch",
				:placeholder="settings.searchPlaceholder",
				type="text")
			button.search-box__submit(type="submit", @click="submitSearch") 
				i.ico-search

	footer.search-box__footer(v-if="showAlpha")
		.search-box__alpha(v-if="showAlpha")
			a.search-box__letter(
				v-for="letter in results.alpha"
				href="",
				:class="{'is-active': letter.toLowerCase() === alphaFilter.toLowerCase()}"
				@click.stop.prevent="submitAlphaFilter(letter)") {{letter.toUpperCase()}}

	//- .search-header__results {{ currentResultStart }} - {{ currentResultsEnd }} of {{ results.totalResultCount }}
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
	name: "SearchBox",
	props: ["searchPlaceholder", "searchButtonText", "showAlpha"],
	computed: {
		...mapGetters(['settings', 'results', 'searchQuery']),
		query: {
			get() {
				return this.searchQuery.searchTerm;
			},
			set(value) {
				this.setQuery(value);
			}
		},

		alphaFilter: {
			get() {
				return this.searchQuery.alphaFilter;
			},
			set(value) {
				if (value === this.searchQuery.alphaFilter) {
					value = "";
				}
				this.setAlphaFilter(value);
			}
		},

		currentResultStart() {
			if (this.results.currentPage == 0) {
				return 1;
			} else {
				return this.results.currentPage * this.results.pageSize + 1;
			}
		},

		currentResultsEnd() {
			if (this.results.currentPage == 0) {
				if (this.total <= this.results.pageSize) {
					return this.totalPages;
				} else {
					return this.results.pageSize;
				}
			} else {
				var max = (this.results.currentPage + 1) * this.results.pageSize + 1;
				if (max > this.total) {
					return this.total;
				} else {
					return max;
				}
			}
		},
	},
	methods: {
		...mapMutations(['setQuery', 'setAlphaFilter']),
		submitAlphaFilter(letter) {
			this.alphaFilter = letter;
			this.$emit("submitalphafilter");
		},
		submitSearch() {
			this.$emit("submitsearch");
		},
	},
};
</script>

<style lang="scss" scoped>
.search-box {
	display: grid;
	grid-auto-columns: minmax(0, 1fr);
	grid-template-areas:
		"header"
		"body"
		"footer";

	gap: 2vw;
	row-gap: 2vw;
	column-gap: 0;

	width: 100%;
	flex: 1 1 100%;

	&__header,
	&__body,
	&__footer {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		>* {
			flex: 1 1 100%;
		}
	}

	&__heading {
		.hero & {
			margin: 0;
			padding: 0;

			font-size: 3rem;
			font-weight: bold;
			color: $white;

			@supports (font-size: clamp(2rem, 3vw, 3rem)) {
				font-size: clamp(2rem, 3vw, 3rem)
			}
		}
	}

	&__form {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 1rem;
	}

	&__input {
		flex: 1 1 100%;

		padding: 2.5% 5%;

		
		border: 0;

		border-radius: 100vw;
	}

	&__submit {
		padding: 0.5rem;
		margin: 0;

		background: transparent;

		border: none;

		.hero & {
			flex: 0 1 auto;

			&,
			i {
				display: flex;
				align-items: center;
				justify-content: center;

				color: $white;
				font-size: 2rem;
				line-height: 1;
			}
		}
	}

	@include mq(lg) {
		grid-template-areas:
			"header body"
			"footer footer";
		grid-auto-columns: 13.75rem minmax(0, 80fr);
		
		gap: 4rem;
		row-gap: 0;
		column-gap: 4rem;
	}

	.hero & {
		padding: 2.5vw 0;
	}
}
</style>